import { useEffect, useRef } from 'react';
import { noop } from 'functions/noop';
import { useIsFirstRender } from './useIsFirstRender';

export const useUpdateEffect = (effect, deps) => {
  const isFirst = useIsFirstRender();

  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    if (!isFirst) {
      return effectRef.current();
    }
    return noop;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
